import { render, staticRenderFns } from "./ComplexModalUser.vue?vue&type=template&id=01642312&"
import script from "./ComplexModalUser.vue?vue&type=script&lang=js&"
export * from "./ComplexModalUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports